import React, { useEffect } from 'react';
import { useIntl } from '@edx/frontend-platform/i18n';

import { windowScrollTo } from '../../../utils';
import { Notifications } from '../components';
import type { ResetPasswordFailureMessageProps } from './types';
import {
  INVALID_FORM,
  TOO_MANY_ATTEMPTS,
  INTERNAL_SERVER_ERROR,
} from './constants';

import messages from './messages';

const ResetPasswordNotification = ({ code, count }: ResetPasswordFailureMessageProps) => {
  const intl = useIntl();

  useEffect(() => {
    windowScrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }, [code, count]);

  if (!code) {
    return null;
  }

  let message: React.ReactNode = '';

  switch (code) {
    case INVALID_FORM:
      message = <p>{intl.formatMessage(messages.enterPassword)}</p>;
      break;
    case TOO_MANY_ATTEMPTS:
      message = <p>{intl.formatMessage(messages.tooManyAttempts)}</p>;
      break;
    case INTERNAL_SERVER_ERROR:
    default:
      message = <p>{intl.formatMessage(messages.internalServerError)}</p>;
      break;
  }

  return (
    <Notifications
      title={intl.formatMessage(messages.errorTitle)}
      message={message}
      count={count}
    />
  );
};

export default ResetPasswordNotification;
